import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { AppTable } from '../../../shared/components';

interface ParamsProps {
  partnerId: string;
}

const PartnerViewPage: React.FC = () => {
  const getPartnerViewTableData = () => {
    const array: Array<JSX.Element> = [];
    return array;
  };
  const { partnerId } = useParams<ParamsProps>();
  console.log(partnerId);
  return (
    <>
      <div className="container pt-3 main-container-div">
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="table_outer_div">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 header-txt">
                    <h5>MOUs in Charge</h5>
                  </div>
                </div>
              </div>

              <AppTable
                head={[
                  '',
                  'Name',
                  'Contact info',
                  '',
                  'Coordinating Faculty',
                  'Expiring Date',
                  '',
                ]}
                data={getPartnerViewTableData()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PartnerViewPage;
